import { render, staticRenderFns } from "./AuftragPositionModal.vue?vue&type=template&id=3151d28d&"
import script from "./AuftragPositionModal.vue?vue&type=script&lang=js&"
export * from "./AuftragPositionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports